import { useEffect, useState } from "react";
import moment from "moment-timezone";

export default function useCountdownToClose(
  afterClose?: string,
  timezone?: string
) {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    if (!afterClose || !timezone) {
      setTimeLeft("");
      return;
    }

    const updateCountdown = () => {
      const now = moment().tz(timezone);
      const [closeHour, closeMinute] = afterClose.split(":").map(Number);

      let closeTime = moment.tz(timezone).set({
        hour: closeHour,
        minute: closeMinute,
        second: 0,
        millisecond: 0,
      });

      if (now.isAfter(closeTime)) {
        closeTime.add(1, "day");
      }

      const diff = closeTime.diff(now);
      if (diff <= 0) {
        setTimeLeft("00:00:00");
        return;
      }

      const duration = moment.duration(diff);

      const h = String(Math.floor(duration.asHours())).padStart(2, "0");
      const m = String(duration.minutes()).padStart(2, "0");
      const s = String(duration.seconds()).padStart(2, "0");

      setTimeLeft(`${h}:${m}:${s}`);
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [afterClose, timezone]);

  return timeLeft;
}
